/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {useMemo} from 'react';
import {Device} from '@ion/core/src/types/entities';
import {
  isLMUDevice as isValidLMUDevice,
  isMDTDevice as isValidMDTDevice
} from '@ion/core/src/utils/DeviceUtils';

/**
 * Provides a utility hook to determine if a device is of type MDT or LMU
 * based on its associated devices.
 *
 * ```typescript
 *
 * import {useValidateDeviceType} from '@ion/applications/src/pages/devices';
 *
 * const {isMDTDevice, isLMUDevice} = useValidateDeviceType();
 *
 * ```
 *
 */
export const useValidateDeviceType = (device: Device) => {
  const associatedDevices = useMemo(() => device?.extensions?.associatedDevices || [], [device]);

  return useMemo(() => {
    let result = {isMDTDevice: false, isLMUDevice: false};

    associatedDevices?.forEach?.(associatedDevice => {
      result = {
        isMDTDevice : isValidMDTDevice({category: associatedDevice?.deviceCategory}),
        isLMUDevice : isValidLMUDevice({category: associatedDevice?.deviceCategory})
      };
    });
    return result;
  }, [associatedDevices]);
};

export default useValidateDeviceType;
